import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import { Container } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import IconButton from "@mui/material/IconButton";
import { NavLink } from "react-router-dom";
import Header from "../../components/Header/Header";
import { ToastContainer } from "react-toastify";
import { getOpenProduction } from "./Slice/orderApprovedSlice";
import { useDispatch, useSelector } from "react-redux";
import CreateIcon from "@mui/icons-material/Create";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";

const ManufacturingOrders = () => {
  let d = new Date();
  const params = {
    columnKeys: [
      "order",
      "customer",
      "product",
      "material_qty",
      "deliveryDeadline",
      "currentDepartment",
    ],
    allColumns: false,
    fileName: `Approved Manufacturing Order ${d.toLocaleDateString()}`,
    sheetName: "Approved Manufacturing Order",
  };

  const gridRef = useRef();
  const onBtExport = useCallback(() => {
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const manufacturingorder = useSelector((state) => state.makeApproved);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getOpenProduction());
  }, []);

  const navigate = useNavigate();

  const editHandle = (e) => {
    navigate("/order-to-manufacturing-edit/" + e);
  };

  const viewProduction = (e) => {
    navigate("/make/production-view/" + e);
  };

  const printProduction = (e) => {
    navigate("/make/production-print/" + e);
  };

  const [rowData, setRowData] = useState();
  useEffect(() => {
    setRowData(manufacturingorder.openProductions);
  }, [manufacturingorder.openProductions]);

  const [columnDefs] = useState([
    {
      field: "rank",
      headerName: "Rank",
      sortable: true,
      // rowDrag: true,
      filter: false,
      cellStyle: { borderRightColor: "#e2e2e2", fontWeight: 600 },
      maxWidth: 80,
    },
    // {
    //   field: "",
    //   checkboxSelection: true,
    //   filter: false,
    //   cellStyle: { borderRightColor: "#e2e2e2" },
    //   maxWidth: 50,
    // },
    {
      field: "order",
      headerName: "Order#",
      sortable: true,
      filter: "agTextColumnFilter",
      cellRenderer: function (params) {
        return (
          <a
            href=""
            rel="noopener"
            onClick={() => printProduction(params.data.id)}
          >
            {" "}
            {params.value}{" "}
          </a>
        );
      },
    },
    {
      field: "customer",
      headerName: "Customer",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      field: "product",
      headerName: "Product",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      field: "material_qty",
      headerName: "Qty",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      field: "deliveryDeadline",
      headerName: "del. Deadline",
      sortable: true,
      cellStyle: { borderRightColor: "#e2e2e2", color: "#e42c00" },
      filter: "agDateColumnFilter",
    },

    {
      field: "currentDepartment",
      headerName: "Current Department",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      field: "action",
      headerName: "Action",
      filter: false,
      cellRenderer: function (params) {
        return (
          <div>
            <Tooltip title="Edit" arrow placement="top">
              <IconButton
                aria-label="edit"
                color="primary"
                onClick={() => editHandle(params.data.id)}
              >
                <CreateIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="View" arrow placement="top">
              <IconButton
                aria-label="approve"
                color="warning"
                onClick={() => viewProduction(params.data.id)}
              >
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
      maxWidth: 180,
    },
  ]);

  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        { statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
        { statusPanel: "agFilteredRowCountComponent" },
        { statusPanel: "agSelectedRowCountComponent" },
        { statusPanel: "agAggregationComponent" },
      ],
    };
  }, []);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      floatingFilter: true,
      sortable: true,
      wrapText: true, // <-- HERE
      autoHeight: true,
    };
  }, []);

  return (
    <>
      <Header />
      <Container maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <div className="grid-tabs-container">
              <Grid item xs={12}>
                <div className="nav-bar">
                  <NavLink
                    to="/makeorder"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    Pending
                  </NavLink>
                  <NavLink
                    to="/manufacturingorders"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    Approved
                  </NavLink>
                  <NavLink
                    to="/manufacturingorder/inprogress"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    In-Progress
                  </NavLink>
                  <NavLink
                    to="/manufacturingorder/stockOut"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    Stock Out
                  </NavLink>
                  <NavLink
                    to="/manufacturingorder/done"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    Done
                  </NavLink>
                  <NavLink
                    to="/manufacturingorder/cancel"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    Cancelled
                  </NavLink>
                  <NavLink
                    to="/make/packing-slip"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    Packing Slip
                  </NavLink>
                </div>
              </Grid>
              <Grid item xs={6}>
                <div className="text-right">
                  {/* <small>Shipping To:</small> */}
                </div>
              </Grid>
            </div>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Grid item xs={12}>
              <div className="action-buttons">
                <Tooltip title="Export Excel" placement="left" arrow>
                  <IconButton color="primary" onClick={onBtExport} size="small">
                    <FileDownloadOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <div className="ag-theme-alpine" style={{ height: 600 }}>
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={columnDefs}
                // rowSelection={'single'}
                rowDragManaged={true}
                defaultColDef={defaultColDef}
                pagination={true}
                paginationPageSize={10}
              ></AgGridReact>
            </div>
          </Grid>
        </Grid>
      </Container>
      <ToastContainer />
    </>
  );
};

export default ManufacturingOrders;
